import { FC, Fragment, RefCallback, useContext, useCallback } from 'react';

import { SnackbarContext } from '@hh.ru/magritte-ui-snackbar/context';
import { SnackbarContainerProps } from '@hh.ru/magritte-ui-snackbar/types';

import styles from './snackbar.less';

export const SnackbarContainer: FC<SnackbarContainerProps> = ({ children, id, ...props }) => {
    const context = useContext(SnackbarContext);

    const ref: RefCallback<HTMLElement> = useCallback(
        (instance) => {
            context.setContainerRef(id, instance);
        },
        [id, context]
    );

    return (
        <Fragment>
            <div {...props} className={styles.snackbarContainer} ref={ref} />
            {children}
        </Fragment>
    );
};
